import React from 'react';
import { Hero } from './components/Hero';
import { Hook } from './components/Hook';
import { Problem } from './components/Problem';
import { Failures } from './components/Failures';
import { Mechanism } from './components/Mechanism';
import { OfferStack } from './components/OfferStack';
import { TargetAudience } from './components/TargetAudience';
import { HowItWorks } from './components/HowItWorks';
import { Proof } from './components/Proof';
import { FAQ } from './components/FAQ';
import { FinalOffer } from './components/FinalOffer';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen bg-parchment font-body selection:bg-gold/30 selection:text-navy-dark" data-id="element-0">
      <main data-id="element-1">
        <Hero data-id="element-2" />
        <Hook data-id="element-3" />
        <Problem data-id="element-4" />
        <Failures data-id="element-5" />
        <Mechanism data-id="element-6" />
        <OfferStack data-id="element-7" />
        <TargetAudience data-id="element-8" />
        <HowItWorks data-id="element-9" />
        <Proof data-id="element-10" />
        <FAQ data-id="element-11" />
        <FinalOffer data-id="element-12" />
      </main>
      <Footer data-id="element-13" />
    </div>;
}